import ErrorPage from 'ContentEditorUI/components/app/ErrorPage';
import { APP_ERRORS } from 'ContentEditorUI/lib/app/constants';
import { jsx as _jsx } from "react/jsx-runtime";
function SecurityViolationPage({
  canContactSupport,
  securityState
}) {
  return /*#__PURE__*/_jsx(ErrorPage, {
    appErrorCategory: APP_ERRORS.SECURITY_VIOLATION,
    canContactSupport: canContactSupport,
    securityState: securityState
  });
}
export default SecurityViolationPage;